import React from 'react';
import Icon from 'components/AppIcon';

export default function MonthSelector({ selectedMonth, onChange }) {
  const months = [];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    months?.push({
      value: `${d?.getFullYear()}-${String(d?.getMonth() + 1)?.padStart(2, '0')}`,
      label: d?.toLocaleString('default', { month: 'long', year: 'numeric' }),
    });
  }

  const currentIdx = months?.findIndex((m) => m?.value === selectedMonth);

  const prev = () => {
    if (currentIdx < months?.length - 1) onChange(months?.[currentIdx + 1]?.value);
  };
  const next = () => {
    if (currentIdx > 0) onChange(months?.[currentIdx - 1]?.value);
  };

  return (
    <div className="flex items-center gap-2 bg-[rgba(255,255,255,0.04)] border border-[rgba(0,229,255,0.1)] rounded-xl px-3 py-2">
      <button onClick={prev} disabled={currentIdx >= months?.length - 1} className="text-[#64748B] hover:text-[#00E5FF] disabled:opacity-30 transition-colors p-1">
        <Icon name="ChevronLeft" size={16} />
      </button>
      <select
        value={selectedMonth}
        onChange={(e) => onChange(e?.target?.value)}
        className="bg-transparent text-[#E2E8F0] text-sm font-medium focus:outline-none cursor-pointer min-w-[160px] text-center"
      >
        {months?.map((m) => (
          <option key={m?.value} value={m?.value} className="bg-[#0D1B2A]">{m?.label}</option>
        ))}
      </select>
      <button onClick={next} disabled={currentIdx <= 0} className="text-[#64748B] hover:text-[#00E5FF] disabled:opacity-30 transition-colors p-1">
        <Icon name="ChevronRight" size={16} />
      </button>
    </div>
  );
}
